import React from 'react';
import './FooterStyles.css';
import { FaFacebook, FaLinkedin, FaMailBulk, FaPhone, FaInstagramSquare } from 'react-icons/fa';
import { FaSquareXTwitter, FaSquareYoutube } from 'react-icons/fa6';
import { Link } from 'react-router-dom'
import logo from '../assets/logo.png'

const Footer2 = () => {
    return (
        <div className='footer'>
            <div className='footer-container'>
                <div className='left'>
                <Link to='/'><img src={logo} alt="Logo" width='100px' height='auto' /></Link>                    <div className='phone'>
                        <h4><FaPhone size={20} style={{ color: '#ffffff', marginRight: '2rem' }} />+27 67 273 4952</h4>
                    </div>
                    <div className='email'>
                    <a href="mailto:info@africaminingsummiti.co.za?cc=africaminingsummit@gmail.com&subject=Website%20User%20%3A%20Enquiry" target="_blank" rel="noopener noreferrer">
                    <h4><FaMailBulk size={20} style={{ color: '#ffffff', marginRight: '2rem' }} /> info@africaminingsummiti.co.za</h4>
                        </a>
                    </div>
                    <div className='email'>
                    <a href="mailto:mining@yepgroup.co.za?cc=africaminingsummit@gmail.com&subject=Website%20User%20%3A%20Enquiry" target="_blank" rel="noopener noreferrer">
                    <h4><FaMailBulk size={20} style={{ color: '#ffffff', marginRight: '2rem' }} /> mining@yepgroup.co.za</h4>
                        </a>
                    </div>
                   
                </div>
                <div className='right'>
                    <h4>Africa Mining Summit Investment 2024</h4>
                    <p>Join us at the Africa Mining Summit Investment 2024 and be a part of shaping the future of Africa's mining industry.</p>
                    <div className='social'>
                        <a href="https://www.facebook.com/profile.php?id=61566390220721" target="_blank" rel="noopener noreferrer">
                            <FaFacebook size={30} style={{ color: '#ffffff', marginRight: '1rem' }} />
                        </a>
                        <a href="https://www.instagram.com/africaminingsummit" target="_blank" rel="noopener noreferrer">
                            <FaInstagramSquare size={30} style={{ color: '#ffffff', marginRight: '1rem' }} />
                        </a>
                        <a href="https://x.com/Africa_MiningS" target="_blank" rel="noopener noreferrer">
                            <FaSquareXTwitter size={30} style={{ color: '#ffffff', marginRight: '1rem' }} />
                        </a>
                        <a href="https://www.youtube.com/@AfricaMiningSummit" target="_blank" rel="noopener noreferrer">
                            <FaSquareYoutube size={30} style={{ color: '#ffffff', marginRight: '1rem' }} />
                        </a>
                        <a href="https://www.linkedin.com/company/africa-mining-summit/about/" target="_blank" rel="noopener noreferrer">
                            <FaLinkedin size={30} style={{ color: '#ffffff', marginRight: '1rem' }} />
                        </a>
                    </div>
                    <p>
                        <a href="/terms-and-conditions" className="terms-link" style={{ color: '#ffffff' }}>
                            Terms and Conditions
                        </a>
                    </p>
                </div>
            </div>
            {/* New Footer Text at the Bottom */}
            <div className='footer-bottom' style={{ textAlign: 'center', marginTop: '2rem', color: '#ffffff' }}>
                <p>Africa Mining Summit Investment @ 2024, brought to you by Yep Group Mining</p>
                <p>
                    Created by <a href="https://stewardsdigital-five.vercel.app/" target="_blank" rel="noopener noreferrer" style={{ color: '#ffffff', textDecoration: 'underline' }}>Stewards Digital</a>
                </p>
            </div>
        </div>
    );
}

export default Footer2;
